import { Minus, Plus } from "lucide-react";

interface HoursStepperProps {
  value: number;
  onChange: (value: number) => void;
  hasError?: boolean;
}

const STEP = 0.5;
const MIN = 0.5;
const MAX = 24;

export function HoursStepper({ value, onChange, hasError }: HoursStepperProps) {
  function decrement() {
    const next = Math.round((value - STEP) * 10) / 10;
    if (next >= MIN) onChange(next);
  }

  function increment() {
    const next = Math.round((value + STEP) * 10) / 10;
    if (next <= MAX) onChange(next);
  }

  function handleInput(e: React.ChangeEvent<HTMLInputElement>) {
    const raw = parseFloat(e.target.value);
    if (!Number.isNaN(raw) && raw >= MIN && raw <= MAX) {
      const rounded = Math.round(raw / STEP) * STEP;
      onChange(Math.round(rounded * 10) / 10);
    }
  }

  return (
    <div className={`hours-stepper${hasError ? " is-error" : ""}`}>
      <button
        type="button"
        className="hours-stepper__btn"
        onClick={decrement}
        disabled={value <= MIN}
        aria-label="Decrease hours"
      >
        <Minus size={16} />
      </button>
      <input
        type="number"
        className="hours-stepper__value"
        value={value}
        onChange={handleInput}
        min={MIN}
        max={MAX}
        step={STEP}
        aria-label="Hours"
      />
      <button
        type="button"
        className="hours-stepper__btn"
        onClick={increment}
        disabled={value >= MAX}
        aria-label="Increase hours"
      >
        <Plus size={16} />
      </button>
    </div>
  );
}
